import * as types from '../actions/types'
import Immutable from 'immutable'
import diff from 'immutablediff'
import patch from 'immutablepatch'


import {
    isPrimitive,
    documento
} from '../utils/helpers'


const INITIAL_STATE = Immutable.fromJS({
    id: null,
    estado: 0,
    solicitud: {},
    btnSaveDisabled: true,
    modified: []
})

export default function (state = INITIAL_STATE, action) {


	switch (action.type) {

        case types.RESETEAR_REDUCER_SOLICITUD_OTROSI:
            return INITIAL_STATE

        case types.OBTENER_SOLICITUD_OTROSI:
			state = state.set('id', action.payload.solicitud.id)
			state = state.set('estado', action.payload.solicitud.estado)
            state = state.set('solicitud', Immutable.fromJS(action.payload.solicitud))
            if (action.payload.reset !== false) {
                state = state.set('modified', INITIAL_STATE.get('modified'))
            }
            state = state.set('btnSaveDisabled', state.get('modified').count() === 0)
			return state


       	default:
            return state

	}
}



// WEBPACK FOOTER //
// ./src/reducers/otrosi.js